/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Winteroccco2setpoint4Inputs */



/**
* | output |
* | --- |
* | "Winter occupied CO2 setpoint" |
*
* @param {Ahu_History_Key_Winteroccco2setpoint4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_winteroccco2setpoint4 = /** @type {((inputs?: Ahu_History_Key_Winteroccco2setpoint4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Winteroccco2setpoint4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Winter occupied CO2 setpoint")
	return /** @type {LocalizedString} */ ("Consigne de CO2 occupation hiver")
});
export { ahu_history_key_winteroccco2setpoint4 as "ahu_history_key_winterOccCO2Setpoint" }